import type { Event } from "@circle-react/types/Event";

import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";

import { internalApi } from "../helpers/urlHelpers";

interface FetchGuestRecurringOccurrencesOptions {
  event: Event;
  params?: Record<string, unknown>;
}

export const fetchGuestRecurringOccurrences = ({
  event,
  params = {},
}: FetchGuestRecurringOccurrencesOptions) => {
  const { slug, space_id: spaceId } = event;
  return reactQueryGet(
    internalApi.eventAttendees.guestRecurringOccurrences({
      slug,
      spaceId,
      params,
    }),
  );
};
